import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para cualquier marca de AirFryer?',
  a: 'Sí, las técnicas se adaptan a modelos de cajón o tipo horno.'
}, {
  q: '¿Es difícil de seguir?',
  a: 'No, está escrito en español simple y con ingredientes que comprás en el Coto o el Día.'
}, {
  q: '¿Tengo que comprar accesorios caros?',
  a: 'Solo necesitás un atomizador de aceite común.'
}, {
  q: '¿Las recetas son para cuántas personas?',
  a: 'Están diseñadas para cenas familiares de 2 a 4 personas.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-charcoal-light py-24 px-6 md:px-12" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-29">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-charcoal rounded-2xl overflow-hidden border border-white/5" data-id="element-31">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-32">
                <span className="font-serif font-bold text-lg md:text-xl text-cream pr-4" data-id="element-33">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-amber" data-id="element-34">
                  <ChevronDown size={24} data-id="element-35" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-36">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-37">
                    <div className="px-6 pb-6 pt-0 font-sans text-cream/70 leading-relaxed" data-id="element-38">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}